module.exports = __webpack_public_path__ + "img/seo-agency.80f7cadf.png";